import { Box, Button, Typography } from '@mui/material'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { styles } from './ReportingOverview.styles'

interface Props {
  canSubmit: boolean
  onAddDistrict: () => void
  onSubmit: () => void
}

export const OverviewActions = ({ canSubmit, onAddDistrict, onSubmit }: Props): JSX.Element => (
  <Box sx={styles.actionsCard}>
    <Box sx={styles.actionsBlock}>
      <Typography variant='subtitle1' sx={styles.actionsTitle}>Add Another District</Typography>
      <Button variant='outlined' endIcon={<ArrowForwardIcon />} onClick={onAddDistrict} data-testid='p2pAddDistrict' sx={{ backgroundColor: 'var(--white)' }}>
        Add a District
      </Button>
    </Box>
    <Box sx={styles.actionsBlock}>
      <Typography variant='subtitle1' sx={styles.actionsTitle}>Ready to Submit?</Typography>
      <Button variant='contained' color='primary' endIcon={<ArrowForwardIcon />} disabled={!canSubmit} onClick={onSubmit} data-testid='p2pSubmitReport'>
        Submit Report
      </Button>
    </Box>
  </Box>
)
